import { Cotizacion as c, CotizacionNull, sentCotizacion } from './Model';
import conCotizacion from './Conexion';
export type Cotizacion = c;
export { CotizacionNull, sentCotizacion, conCotizacion };
export const utilCot = { Null: CotizacionNull, sent: sentCotizacion, con: conCotizacion };